import { Component, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller, Swiper } from 'swiper';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller]);


@Component({
  selector: 'app-sport-layout',
  templateUrl: './sport-layout.component.html',
  styleUrls: ['./sport-layout.component.css']
})
export class SportLayoutComponent extends BaseClass<any> implements OnInit {

  constructor(public service: WebserviceService, public _common: CommonService) {
    super(document);
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  ngOnInit(): void {
    var swiper1 = new Swiper(".exchange-slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

}
